import { Button, Table, Typography } from 'antd';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import TradeProcessRecordService from '../../services/TradeProcessHistoryService';
import { exportToExcel } from '../../util/Common';

const { Title, Text } = Typography;

const MatchTradeList = ({ matchingProcessId, tradeWindow }) => {
  const [matchTradeList, setMatchTradeList] = useState();
  const [loading, setLoading] = useState(false);
  const { showNotification } = useAuth();
  const loadData = async () => {
    try {
      setLoading(true);
      const result = await TradeProcessRecordService.getMatchTradeList({ matchingProcessId });
      setLoading(false);
      if (result.success) {
        setMatchTradeList(result.matchTradeList);
      } else {
        showNotification('error', result.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadData();
  }, []);
  
  const tableColumns = [
    {
      title: 'Fix Execution ID',
      dataIndex: 'fixExecuteId',
      key: 'fixExecuteId',
    },
    {
      title: 'Security Code',
      dataIndex: 'securityCodeAtBroker',
      key: 'securityCodeAtBroker',
    },
    // {
    //   title: 'Order Side Type',
    //   dataIndex: 'orderSideTypeAtBroker',
    //   key: 'orderSideTypeAtBroker',
    // },
    {
      title: 'Quantity',
      dataIndex: 'quantityAtBroker',
      key: 'quantityAtBroker',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Amount',
      dataIndex: 'amountAtBroker',
      key: 'amountAtBroker',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
  ];

  const handleExport = () => {
    const data = matchTradeList.map((item) => {
      return {
        "Fix Execution ID" : item.fixExecuteId,
        "Security Code": item.securityCodeAtBroker,
        "Quantity": item.quantityAtBroker,
        "Amount" : item.amountAtBroker
      }
    })
      const year = tradeWindow.substring(0, 4);
      const month = tradeWindow.substring(4, 6);
      const day = tradeWindow.substring(6, 8);
    
    exportToExcel(data,"TradeProcessRecord("+day+month+year+")")
  }

  return (
    <>
      <Table
        columns={tableColumns}
        dataSource={matchTradeList}
        size={'large'}
        scroll={{
          x: 'max-content',
        }}
        loading={loading}
        bordered
        pagination= {{
          pageSize: 5
        }}
        footer={() => (
          <Button type="primary" size="middle" onClick={handleExport}>
              Export
          </Button>
        )}
      />
    </>
  );
};

export default MatchTradeList;
